import Cookies from 'js-cookie';

// const curToken = 'app-Acceleration-ht';
const curToken = 'agotoz-yecaixitong';

export function getToken() {
  return Cookies.get(curToken);
}

/**
 * 设置所有的token，登录时用
 * @param {*} token 
 */
export function setToken(token) {
  Cookies.set(curToken, token);
}

/**
 * 移除token
 */
export function removeToken() {
  Cookies.remove(curToken);
  return;
}
